import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../utils/axios';
import { FOOTBALLOP_GAME_CARD_LIST } from 'src/constants/queryKeys';

export const networkGetFootbalopGameCardInfo = async (gameCardId) => {
  const res = await axiosInstance.post(`FootbalopGameCard/Info1/${gameCardId}`);
  return res;
};

export const networkGetFootbalopGameCardList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`FootbalopGameCard/List1/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchFootbalopGameCardList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [FOOTBALLOP_GAME_CARD_LIST, pageIndex],
    queryFn: () => networkGetFootbalopGameCardList(pageIndex, pageSize),
  });
}

export const networkUpdateFootbalopGameCard = async (gameCardId, payload) => {
  const res = await axiosInstance.post(`FootbalopGameCard/Update/${gameCardId}`, payload);
  return res;
};

export const networkRemoveFootbalopGameCard = async (gameCardId) => {
  const res = await axiosInstance.post(`FootbalopGameCard/Remove/${gameCardId}`);
  return res;
};

export const networkCreateFootbalopGameCard = async (payload) => {
  const res = await axiosInstance.post('FootbalopGameCard/Insert', payload);
  return res;
};
